const initialState = {
	isLoading: 0,
	error: {},
    codesAvailable: false
}

export default (state = initialState, action) => {
	switch (action.type){
		case 'SALES_CODES_LOADING':
			return {
				...state,
				isLoading: 1
			}
		case 'SALES_CODES_ERROR':
			return {
				...state,
				isLoading: 0,
				error: action.err
			}
		case 'SALES_CODES_SUCCESS':
			return {
				...state,
				codesAvailable: action.payload,
				isLoading: 0
			}

		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/store/reducers/saleCodes.js